var hasIntersection = require('./hasIntersection');
/**
 * Compares the paths passed in with the tree.  Any of the paths that are in
 * the tree will be stripped from the paths.
 *
 * **Does not mutate** the incoming paths object.
 * **Proper subset** only matching.
 *
 * @param {Array} paths - A list of paths (complex or simple) to strip the
 * intersection
 * @param {Object} tree -
 * @public
 */


module.exports = function pathsComplementFromLengthTree(paths, tree) {
  var out = [];
  var outLength = -1;

  for (var i = 0, len = paths.length; i < len; ++i) {
    // If this does not intersect then add it to the output.
    var path = paths[i];

    if (!hasIntersection(tree[path.length], path, 0)) {
      out[++outLength] = path;
    }
  }

  return out;
};